import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MenuItem, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { InventoryService } from '../../../services/inventory.service';
import _ from 'lodash';
import { AdministratorService } from '../../../services/administrator.service';
import { Color, GSTInfo, Product, gridPageRequest } from '../../../model/common/common.model';
import { LoaderComponent } from '../../loader/loader.component';
import { color, ProductGroups, UnitsOfMeasure } from '../../../model/administration.model';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GstListLookupComponent } from '../gst-list-lookup/gst-list-lookup.component';
import { InventoryStatusLookupComponent } from '../inventory-status-lookup/inventory-status-lookup.component';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { LedgerLookupComponent } from '../ledger-lookup/ledger-lookup.component';
import { Observable, catchError, forkJoin, of, switchMap } from 'rxjs';
import { VendorLookupComponent } from '../vendor-lookup/vendor-lookup.component';
import { PurchaseorderService } from '../../../services/purchaseorder.service';
@Component({
  selector: 'app-viewproduct-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent, TieredMenuModule],
  providers: [MessageService],
  templateUrl: './viewproduct-lookup.component.html',
  styleUrl: './viewproduct-lookup.component.scss'
})
export class viewproductLookupComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;
  productId: any;
  filterCategorys: any[] = [];
  selectedCustomerEmail: string | null = null;
  selectedCustomerName: string | null = null;
  vendorState: string | undefined;
  childDialogRef!: DynamicDialogRef;
  hide: boolean = false;
  ColorDropdown: Color[] = [];
  filtercolor: color[] = [];
  gstRateReadonly: boolean = false;
    allHSNCodes: any[] = []; 
  filteredHSNCodes: any[] = [];
gstDialogRef!: DynamicDialogRef;
  constructor(private config: DynamicDialogConfig, private messageService: MessageService, private router: Router, private sanitizer: DomSanitizer, private inventoryService: InventoryService,
    private porderservice: PurchaseorderService, private route: ActivatedRoute, private administratorService: AdministratorService, public dialogService: DialogService, public ref: DynamicDialogRef,  public productDialogRef: DynamicDialogRef) { }

  activeIndex: number = 0;
  loader: boolean = false;
  RoleId: number = 0;
  iseditProduct: boolean = false;
  editProductData: any;
  submitted: boolean = false;
  value: string = '';
  Attributes: any[] = [];
  saveImage: Blob | undefined;
  isManual: boolean = false;
  deletedImage: string | undefined;
  SalesOrderLineItemId: number | undefined;
  filteredColors: Color[] = [];

  selectedFile: File | null = null;
  previewImage: string | null = null;

  items: MenuItem[] | undefined;

  product: Product[] = [];

  createProductForm = new FormGroup({
    ProductId: new FormControl(0),
    ProductName: new FormControl('', Validators.required),
    ProductCode: new FormControl('', Validators.required),
    ProductDescription: new FormControl(''),
    ProductImage: new FormControl(),
    // CheckBox
    CanBeSold: new FormControl(false),
    CanBePurchased: new FormControl(false),
    CanBeRented: new FormControl(false),
    isactive: new FormControl(true, Validators.requiredTrue),
    IsTaxable: new FormControl(true),
    isLotTracking: new FormControl(false),
    IsInventory: new FormControl(true),
    isLocationTracking: new FormControl(false),
    isSerialTracking: new FormControl(false),
    // General Information
    ProductType: new FormControl('', Validators.required),
    producttypedropdown: new FormControl(''),
    UOM: new FormControl(''),
    UnitsofMeasureId: new FormControl(null),
    UnitsOfMeasure: new FormControl('', Validators.required),
    PurchasingUom: new FormControl('EA'),
    SellingUom: new FormControl('EA'),
  SalesPrice: new FormControl(0.00),      
    StandardCost: new FormControl(0.00),
    Weight: new FormControl(0),
    CategoryId: new FormControl(0), //Product Category
    // Category: new FormControl(''),
    CategoryValue: new FormControl(''),
    // SubCategoryId: new FormControl(''), //Product Category
    // SubCategory: new FormControl(''), //Product Category
    // Sales
    // GST: new FormControl(''),
    // Inventory
    GSTId: new FormControl(),
    gstRate: new FormControl(),
    HSNCode: new FormControl(),
    Barcode: new FormControl(''),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(),
    CostCalculation: new FormControl(),
    manualEntry: new FormControl(true),
    Vendor: new FormControl(),
    VendorName: new FormControl(''),
    VendorCode: new FormControl(),
    Add: new FormControl(),
    AddressId: new FormControl(),
    ProductSpecification: new FormControl(),
    ProductSize: new FormControl(),
    VendorId: new FormControl(),
    ColorId: new FormControl<any>(null),
    ColorName: new FormControl<any>(null),
    ProductGroupName: new FormControl(null),
    GroupId: new FormControl<any>(null),
    SubCategoryName: new FormControl(null),
    SubCategoryId: new FormControl<any>(null),
    VendorProductCode: new FormControl(null),
    StandardType: new FormControl(),
IsServiceType: new FormControl<boolean | null>(null)  });

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  UOMDropdown: UnitsOfMeasure[] = [];
  filteruom: UnitsOfMeasure[] = [];
  ProductTypeDropdown: any[] = [];
  CategoryDropdown: any[] = [];
  filterproducttype: any[] = [];
  GSTList: GSTInfo[] = [];
  ProductGroupsDropdown: ProductGroups[] = [];
  filterProductGroups: ProductGroups[] = [];
  ProductSubCategoryDropdown: any[] = [];
  filterProductSubCategory: any[] = [];
  ngOnInit(): void {
    this.productId = this.config.data?.productId;
    this.createProductForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    if (this.config.data?.productData) {
      this.editProductData = this.config.data.productData;
      this.EditProduct(this.editProductData);
    } else if (this.productId) {
      this.getProduct(this.pageRequest);
    }

    this.items = [
      {
        label: 'Inventory Status',
        command: () => this.showInventoryStatus(),
      },
      {
        label: 'Ledger',
        command: () => this.showLedger(),
      },
    ];
    this.getUOM();
    this.getProductType();
    this.getCatagory();
    this.getProductGroups();
    // this.getColor();
    this.getProductSubCategory();
    // this.getSystemConfigData();
  }



  setBase64Image(imageBase64: string) {
    this.previewImage = `data:image/jpeg;base64,${imageBase64}`;
  }


  EditProduct(data: any) {
    try {
      const productData = JSON.parse(data);
      if (!productData?.productId) return;

      this.loader = true;
      this.iseditProduct = true;

      this.inventoryService.getProductById(productData.productId).subscribe({
        next: (res: any) => {
          this.loader = false;

          this.createProductForm.patchValue({
            ProductId: res.productId,
            ProductCode: res.productCode,
            ProductName: res.productName,
            ProductImage: res.productImage,
            ProductDescription: res.productDescription,

            CostCalculation: res.costCalculation,
            CanBePurchased: res.canBePurchased,
            CanBeRented: res.canBeRented,
            CanBeSold: res.canBeSold,
            isactive: res.isActive,
            IsTaxable: res.isTaxable,
            IsInventory: res.isInventory,

            isLocationTracking: res.isLocationTracking,
            isLotTracking: res.isLotTracking,
            isSerialTracking: res.isSerialTracking,

            ProductType: res.productType,
            UnitsOfMeasure: res.unitsOfMeasure,
            UnitsofMeasureId: res.unitsofMeasureId,
            PurchasingUom: res.purchasingUom,
            SellingUom: res.sellingUom,

            SalesPrice: res.salesPrice,
            StandardCost: res.standardCost,
            Weight: res.weight,

            CategoryId: res.categoryId,
            CategoryValue: res.category?.categoryName || '',

            SubCategoryId: res.subCategoryId,
            SubCategoryName: res.subCategory?.subCategoryName || '',

            ProductGroupName: res.productGroups?.productGroupName || '',
            GroupId: res.groupId,

            HSNCode: res.hsnCode,
            GSTId: res.gstId,
            gstRate: res.gstRate,

            Barcode: res.barcode,
            ProductSize: res.productSize,

            VendorId: res.vendorId,
            VendorName: res.vendor?.vendorName || '',
            VendorProductCode: res.vendorProductCode,
            UOM: res.unitsOfMeasure
            ,
            ColorId: res.color?.colorId || '',
            ColorName: res.color?.colorName || '',

            ProductSpecification: res.productSpecification,
            IsServiceType: res.isServiceType,
            StandardType: res.standardType,
            producttypedropdown: res.productTypeName,

            UpdatedBy: localStorage.getItem('username')
          });
          this.createProductForm.get('IsServiceType')?.disable();

          if (res.productImage) {
            this.setBase64Image(res.productImage);
          }
        },
        error: (err) => {
          console.error(err);
          this.loader = false;
        }
      });

    } catch (error) {
      console.error('Invalid product data', error);
    }
  }

  getProduct(query: gridPageRequest): void {
    this.inventoryService.getProductById(this.productId).subscribe({
      next: (data: any) => {
        this.loader = false;
        this.iseditProduct = true;
        this.createProductForm.patchValue({
          ProductId: data.productId,
          ProductCode: data.productCode,
          ProductName: data.productName,
          ProductImage: data.productImage,
          ProductDescription: data.productDescription,
          CostCalculation: data.costCalculation,
          CanBePurchased: data.canBePurchased,
          CanBeRented: data.canBeRented,
          CanBeSold: data.canBeSold,
          isactive: data.isActive,
          IsTaxable: data.isTaxable,
          IsInventory: data.isInventory,
          isLocationTracking: data.isLocationTracking,
          isLotTracking: data.isLotTracking,
          isSerialTracking: data.isSerialTracking,
          ProductType: data.productType,
          UOM: data.unitsofMeasures,
          UnitsOfMeasure: data.unitsOfMeasure,
          UnitsofMeasureId: data.unitsofMeasureId,
          PurchasingUom: data.purchasingUom,
          SellingUom: data.sellingUom,
          SalesPrice: data.salesPrice,
          StandardCost: data.standardCost,
          Weight: data.weight,
          CategoryValue: data.category.categoryName,
          CategoryId: data.categoryId,
          HSNCode: data.hsnCode,
          GSTId: data.gstId,
          gstRate: data.gstRate,
          producttypedropdown: data.productType,
          Barcode: data.barcode,
          ColorId: data.colorId,
          ColorName: data.ColorName,
          ProductGroupName: data.ProductGroupName,
          GroupId: data.GroupId,
          SubCategoryName: data.SubCategoryName,
          SubCategoryId: data.SubCategoryId,
          VendorProductCode: data.VendorProductCode,
          StandardType: data.StandardType,
        });
        if (data.productImage) {
          this.setBase64Image(data.productImage);
        }
      }
    });
  }


  showInventoryStatus() {
    this.ref = this.dialogService.open(InventoryStatusLookupComponent, {
      header: `Inventory Status for Product Code: ${this.createProductForm.controls.ProductCode.value}`,
      width: '80%',
      data: { ProductCode: this.createProductForm.controls.ProductCode.value }

    });

  }

  showLedger() {
    this.ref = this.dialogService.open(LedgerLookupComponent, {
      header: `Ledger Card for Product: ${this.createProductForm.controls.ProductCode.value}`,
      width: '80%',
      data: { ProductCode: this.createProductForm.controls.ProductCode.value, ProductId: this.createProductForm.controls.ProductId.value }

    });

  }
  validateForm() {
    let isValid = true;
    if (this.createProductForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required fields' });
      isValid = false;
    }

    return isValid;
  }

  updateProduct() {
    this.submitted = true;

    if (!this.validateForm()) return;

    this.loader = true;

    // Default Weight
    if (!this.createProductForm.controls.Weight.value) {
      this.createProductForm.controls.Weight.setValue(0);
    }

    // Explicitly remove or nullify ColorId
    if (this.createProductForm.contains('ColorId')) {
      this.createProductForm.patchValue({ ColorId: null });
    }

    const groupValue = this.createProductForm.get('GroupId')?.value;
    const subCategoryValue = this.createProductForm.get('SubCategoryId')?.value;

    const hasValidIds = groupValue && subCategoryValue &&
      typeof groupValue === 'number' && typeof subCategoryValue === 'number';

    if (hasValidIds) {
      this.callUpdateAPI();
    } else {
      const groupName = this.createProductForm.get('ProductGroupName')?.value || '';
      const subCategoryName = this.createProductForm.get('SubCategoryName')?.value || '';

      forkJoin({
        group: this.administratorService.getGroupByName(groupName).pipe(catchError(() => of(null))),
        subCategory: this.administratorService.getSubCategoryByName(subCategoryName).pipe(catchError(() => of(null)))
      }).subscribe({
        next: ({ group, subCategory }) => {
          this.createProductForm.patchValue({
            GroupId: group?.productGroupId ?? null,
            SubCategoryId: subCategory?.subCategoryId ?? null
          });

          this.callUpdateAPI();
        },
        error: (error) => {
          console.error('Error fetching metadata', error);
          this.loader = false;
        }
      });
    }
  }


 private callUpdateAPI() {
  this.loader = true;

  let isServiceType = this.createProductForm.get('IsServiceType')?.value;
  const payload = { ...this.createProductForm.value,isServiceType };
  this.inventoryService.updateProduct(payload).subscribe({
    next: (data: any) => {
      this.loader = false;

      if (data) {
        this.productId = data;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Product updated successfully.'
        });

        const updatedProduct = { ...payload };
        console.log("Closing dialog with data:", updatedProduct);
        this.productDialogRef.close(updatedProduct);

        if (this.selectedFile) {
          this.uploadImage(this.productId);
        }
      }
    },
    error: (error: any) => {
      console.error('Error updating product', error);
      this.loader = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to update product.'
      });
    }
  });
}


  updateLineItems(data: string) {
    this.porderservice.getPurchaseOrderLineitemById(data).subscribe({
      next: (lineItems: any[]) => {
        if (lineItems.length > 0) {
          lineItems.forEach((lineItem) => {
            lineItem.ProductName = this.createProductForm.controls.ProductName.value;
            lineItem.SalesPrice = this.createProductForm.controls.SalesPrice.value;
            lineItem.StandardCost = this.createProductForm.controls.StandardCost.value;
            lineItem.Weight = this.createProductForm.controls.Weight.value;

            this.porderservice.updatePurchaseOrderLineitem(lineItem).subscribe({
              next: () => {
                console.log(`Line Item ${lineItem.SalesOrderLineItemId} updated successfully.`);
              },
              error: (err: any) => {
                console.error(`Failed to update Line Item ${lineItem.SalesOrderLineItemId}`, err);
              }
            });
          });
        }
      },
      error: (error: any) => {
        console.error('Error fetching line items for product:', error);
      }
    });
  }


  uploadImage(productId: number) {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('image', this.selectedFile);
      this.inventoryService.uploadImage(productId, formData).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Image uploaded successfully.' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Image upload failed.' });
          }
        },
      });
    }
  }

  get formControls() {
    return this.createProductForm.controls;
  }
  filterProductType(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.ProductTypeDropdown as any[]).length; i++) {
      let productType = (this.ProductTypeDropdown as any[])[i];
      if (productType.productTypeCode.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        productType.productTypeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(productType);
      }
    }

    this.filterproducttype = filtered;
  }
  setProductType(data: any) {
    if (data.value) {
      const productCode = _.toString(data.value.productTypeCode);
      this.createProductForm.controls.ProductType.setValue(productCode);
      this.getProductTypeNameByCode(productCode);
    }
  }
  getProductTypeNameByCode(productTypeCode: string) {
    this.inventoryService.getProductByType(productTypeCode).subscribe({
      next: (data: any) => {
        if (Array.isArray(data) && data.length > 0) {
          const productType = data[0];
          if (productType.productTypeName) {
            this.createProductForm.controls.producttypedropdown.setValue(productType.productTypeName);
          } else {
            this.createProductForm.controls.producttypedropdown.setValue('Unknown');
          }
        } else {
          this.createProductForm.controls.producttypedropdown.setValue('Unknown');
        }
      },
      error: (error: any) => {
        console.error('Error fetching product type name:', error);
        this.createProductForm.controls.producttypedropdown.setValue('Error fetching name');
      }
    });
  }
  setPurchasingUOM(event: any) {
    if (event.value) {
      this.createProductForm.controls.PurchasingUom.setValue(_.toString(event.value.unitsofMeasure));
    }
  }

  setSellingUOM(event: any) {
    if (event.value) {
      this.createProductForm.controls.SellingUom.setValue(_.toString(event.value.unitsofMeasure));
    }
  }

  setCategory(event: any) {
    if (event.value) {
      const selectedCategoryId = event.value.categoryId;
      this.createProductForm.controls.CategoryId.setValue(selectedCategoryId);
      this.filterProductGroups = this.ProductSubCategoryDropdown.filter(
        (sub: any) => sub.categoryId === selectedCategoryId
      );
    }
  }
  setUOM(event: any) {
    if (event.value) {
      this.createProductForm.controls.UnitsofMeasureId.setValue(event.value.unitsofMeasureId);
      this.createProductForm.controls.UnitsOfMeasure.setValue(_.toString(event.value.unitsofMeasure));
    }
  }
  filterUOM(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.UOMDropdown as any[]).length; i++) {
      let uom = (this.UOMDropdown as any[])[i];
      if (uom.unitsofMeasureCode.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        uom.unitsofMeasure.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(uom);
      }
    }

    this.filteruom = filtered;
  }

  filtersCatagory(event: any) {
    const query = event.query.toLowerCase();
    const selectedProductGroupName = this.createProductForm.controls.ProductGroupName.value;

    if (!selectedProductGroupName) {
      this.filterCategorys = [];
      return;
    }

    this.administratorService.getGroupByName(selectedProductGroupName).subscribe((response: any) => {
      const selectedProductGroupId = response?.productGroupId;

      if (!selectedProductGroupId) {
        this.filterCategorys = [];
        return;
      }

      const productGroup = (this.ProductGroupsDropdown as any[]).find(pg => pg.productGroupId === selectedProductGroupId);

      if (!productGroup || !Array.isArray(productGroup.category)) {
        this.filterCategorys = [];
        return;
      }

      this.filterCategorys = productGroup.category.filter((category: any) => {
        return category.categoryName?.toLowerCase().startsWith(query) ||
          category.categoryCode?.toLowerCase().startsWith(query);
      });
    });
  }

  getVendor() {
    this.childDialogRef = this.dialogService.open(VendorLookupComponent, {
      header: 'Vendor List',
      width: '60%',
    });

    this.childDialogRef.onClose.subscribe((data: any) => {
      if (data) {
        this.createProductForm.patchValue({
          VendorName: data.vendorName,
          VendorId: data.vendorId,
          VendorCode: data.vendorCode,
          AddressId: data.addressId,
          Add: `${data.address.addressLine1}, ${data.address.city} ${data.address.state}, ${data.address.country}, ${data.address.zip}`
        });
        this.vendorState = data.address.state;
        this.selectedCustomerEmail = data.email;
        this.selectedCustomerName = data.vendorName;
      }
    });
  }

  getCatagory() {
    this.inventoryService.getCatagory().subscribe({
      next: (data: any) => {
        this.CategoryDropdown = data.category;
      },
      error: error => {
        console.log(error);
      }
    });
  }
  getProductType() {
    this.inventoryService.getProductType().subscribe({
      next: (data: any) => {
        this.ProductTypeDropdown = data.productType;
      },
      error: error => {
        console.log(error);
      }
    });
  }
  getUOM() {
    this.administratorService.getAllUnitsOfMeasure(this.pageRequest).subscribe({
      next: (data: any) => {
        // console.log(data.unitsofMeasures);
        this.UOMDropdown = data.unitsofMeasures;
      },
      error: error => {
        console.log(error);
      }
    });
  }
getGSTList() {
  const type = this.createProductForm.get('IsServiceType')?.value;

  if (type === null || type === undefined) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Validation',
      detail: 'Please select Type (Goods or Service) first.'
    });
    return;
  }
  let typeBoolean: boolean;
  if (type === false) {
    typeBoolean = false; 
  } else if (type === true) {
    typeBoolean = true; 
  } else {
    this.messageService.add({
      severity: 'warn',
      summary: 'Validation',
      detail: 'Please select Type (Goods or Service) first.'
    });
    return;
  }

  this.ref = this.dialogService.open(GstListLookupComponent, {
    header: 'GST List',
    width: '60%',
    data: { type: typeBoolean }
  });

  this.ref.onClose.subscribe((data: GSTInfo) => {
    if (data) {
      this.createProductForm.controls.HSNCode.setValue(data.hsnCode);
      this.createProductForm.controls.GSTId.setValue(_.toNumber(data.gstId));
      const isTaxable = data.gstRate > 0;
      this.createProductForm.controls.IsTaxable.setValue(isTaxable);
      this.createProductForm.controls.gstRate.setValue(data.gstRate);
    }
  });
}
  // getSystemConfigData(): void {
  //   this.loader = true;
  //   const appKey = 'hide.columns_Products';

  //   this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
  //     next: (response: any) => {
  //       this.loader = false;
  //       if (response.appKeycode === appKey) {
  //         this.hide = response.data === 'N';
  //       }
  //     },
  //     error: error => {
  //       console.error('Error fetching System Config Data:', error);
  //       this.loader = false;
  //     }
  //   });
  // }

  // getColor() {
  //   this.administratorService.getAllColour(this.pageRequest).subscribe({
  //     next: (data: any) => {
  //       // console.log(data.unitsofMeasures);
  //       this.ColorDropdown = data.color;
  //     },
  //     error: error => {
  //       console.log(error);
  //     }
  //   });
  // }

  // filterColor(event: any) {
  //   let filtered: any[] = [];
  //   let query = event.query;

  //   for (let i = 0; i < (this.ColorDropdown as any[]).length; i++) {
  //     let color = (this.ColorDropdown as any[])[i];
  //     if (color.colorCode.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
  //       color.color.toLowerCase().indexOf(query.toLowerCase()) === 0) {
  //       filtered.push(color);
  //     }
  //   }

  //   this.filtercolor = filtered;
  // }

  // setColor(event: any) {
  //   if (event) {
  //     this.createProductForm.controls.ColorName.setValue(event.colorName);

  //   }
  // }
  getProductGroups() {
    this.administratorService.getAllProductGroups(this.pageRequest).subscribe({
      next: (data: any) => {
        this.ProductGroupsDropdown = data.productGroups;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  // filterProductGroup(event: any) {
  //   let filtered: any[] = [];
  //   let query = event.query;

  //   for (let i = 0; i < (this.ProductGroupsDropdown as any[]).length; i++) {
  //     let ProductGroups = (this.ProductGroupsDropdown as any[])[i];
  //     if (ProductGroups.productGroupName.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
  //       ProductGroups.ProductGroups.toLowerCase().indexOf(query.toLowerCase()) === 0) {
  //       filtered.push(ProductGroups);
  //     }
  //   }

  //   this.filterProductGroups = filtered;
  // }

  filterProductGroup(event: any) {
    const query = event.query.toLowerCase();

    this.filterProductGroups = this.ProductGroupsDropdown.filter(pg =>
      pg.productGroupName.toLowerCase().includes(query)
    );
  }


  setProductGroups(event: any) {
    if (event?.value?.productGroupName) {
      this.createProductForm.controls.ProductGroupName.setValue(event.value.productGroupName);
      this.createProductForm.controls.GroupId.setValue(event.value.productGroupId);
    }
  }

  getProductSubCategory() {
    this.inventoryService.getCatagory().subscribe({
      next: (data: any) => {
        this.ProductSubCategoryDropdown = data.category.flatMap((cat: any) => cat.subCategory || []);
      },
      error: error => console.log(error)
    });
  }

  filterSubCategory(event: any) {
    const query = event.query.toLowerCase();
    const selectedCategoryId = this.createProductForm.controls.CategoryId.value;
    const selectedCategory = this.CategoryDropdown.find(
      (cat: any) => cat.categoryId === selectedCategoryId
    );

    if (!selectedCategory || !selectedCategory.subCategory) {
      this.filterCategorys = [];
      return;
    }

    this.filterCategorys = selectedCategory.subCategory.filter((sub: any) =>
      sub.subCategoryName?.toLowerCase().includes(query) ||
      sub.subCategoryCode?.toLowerCase().includes(query)
    );
  }



  setProductSubCategory(event: any) {
    if (event.value) {
      this.createProductForm.controls.SubCategoryName.setValue(event.value.subCategoryName);
      this.createProductForm.controls.SubCategoryId.setValue(event.value.subCategoryId);
    }
  }


  standardTypes = [
    { id: 1, StandardType: 'Standard' },
    { id: 2, StandardType: 'Non Standard' }
  ];

  filterStandardtype = this.standardTypes;

  setstandardtype(event: any) {
    if (event.value) {
      this.createProductForm.controls.StandardType.setValue(event.value.StandardType); // Just the string
    }
  }

  filterstandardtype(event: any) {
    const query = event.query.toLowerCase();
    this.filterStandardtype = this.standardTypes.filter(item =>
      item.StandardType.toLowerCase().includes(query)
    );
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    const fileSizeKB = Math.round(file.size / 1024);

    if (fileSizeKB > 5000) {
      this.fileInput.nativeElement.value = '';
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select an image file up to 5MB in size.' });
      return;
    }

    if (!['image/jpeg', 'image/png'].includes(file.type)) {
      this.fileInput.nativeElement.value = '';
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a valid image (JPEG/PNG).' });
      return;
    }

    if (file) {
      this.selectedFile = file;
      this.createImagePreviewAndAttachToForm(file);
    }
  }

  createImagePreviewAndAttachToForm(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      const base64WithPrefix = reader.result as string;

      this.previewImage = base64WithPrefix;

      const base64Only = base64WithPrefix.split(',')[1];

      this.createProductForm.controls['ProductImage'].setValue(base64Only);
    };
    reader.readAsDataURL(file);
  }

  deleteImage(): void {
    if (this.selectedFile || this.previewImage) {
      this.selectedFile = null;
      this.previewImage = null;
      this.createProductForm.controls['ProductImage'].setValue(null);
      this.fileInput.nativeElement.value = '';
    }
  }

  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault(); // Prevent form submission on Enter key press

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }

  filterColors(event: any) {
    const query = event.query.toLowerCase();
    this.filteredColors = this.ColorDropdown.filter(color =>
      color.colorName?.toLowerCase().includes(query)
    );
  }
onTypeChange() {

  const type = this.createProductForm.get('IsServiceType')?.value;

  if (type === null || type === undefined) return;

  if (type === false) {
    this.filteredHSNCodes = this.allHSNCodes.filter(hsn => hsn.IsService === 0);
  } else {
    this.filteredHSNCodes = this.allHSNCodes.filter(hsn => hsn.IsService === 1);
  }

  const selectedHSN = this.createProductForm.get('HSNCode')?.value;
  if (selectedHSN) {
    const match = this.filteredHSNCodes.find(h => h.HSNCode === selectedHSN);
    if (!match) {
      this.createProductForm.get('HSNCode')?.setValue(null);
    }
  }
}
}

